// extracted by mini-css-extract-plugin
export default {"messageLogs":"IframeMessageLog_messageLogs__Xrxcy"};